import React, { useEffect, useState } from "react";
import { ShoppingCart } from "lucide-react";
import "./CartIcon.css";
import { useSettings } from "../context/SettingsContext";
const CartIcon = ({ onClick }) => {
  const [totalQty, setTotalQty] = useState(0);
 const { settings, loading } = useSettings();
  useEffect(() => {
    const updateCart = () => {
      const cartData = JSON.parse(localStorage.getItem("cart")) || [];
      let qty = 0;
      cartData.forEach((item) => {
        qty += item.quantity;
      });
      setTotalQty(qty);
    };

    updateCart(); // initial

    // Optional: listen to storage changes from other tabs
    window.addEventListener("storage", updateCart);

    return () => window.removeEventListener("storage", updateCart);
  }, []);

  // if (totalQty === 0) return null; // hide if empty

  return (
    <div className="cart-icon-container  cart-icon" 
style={{
  background: settings?.cart_btn_color || "#000000ff",
   color: settings?.cart_btn_text_color || "#ffffff",
}}
onMouseEnter={(e) => {
  e.currentTarget.style.background =
    settings?.cart_btn_hover || "#f59e0b";
}}
onMouseLeave={(e) => {
  e.currentTarget.style.background =
    settings?.cart_btn_color || "#ffffff";
}} onClick={onClick}>
      <ShoppingCart size={28} />
      <span className="cart-badge">{totalQty}</span>
    </div>
  );
};

export default CartIcon;
